import React from "react";

export function BranchAvatar({ initials, color = "#2F6BFF", size = 40, className = "" }) {
  return (
    <span
      className={`grid place-items-center rounded-xl font-bold text-white shrink-0 ${className}`}
      style={{ width: size, height: size, background: color, fontSize: size * 0.36, letterSpacing: "0.02em" }}
    >
      {initials}
    </span>
  );
}

export function OperatorAvatar({ initials, color = "#6FA015", size = 32, className = "" }) {
  return (
    <span
      className={`grid place-items-center rounded-full font-bold text-white shrink-0 ${className}`}
      style={{ width: size, height: size, background: color, fontSize: size * 0.38 }}
    >
      {initials}
    </span>
  );
}

export default BranchAvatar;
